import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { request } from "../../config/request.ts";
import { toast } from "react-toastify";

interface DeleteConfirmationProps {
  open: boolean;
  title?: string;
  message?: string;
  apiEndpoint: string;
  deleteId: any;
  onCancel: () => void;
  refetchApi?: () => void;
}

export default function DeleteConfirmation({
  open,
  title = "Confirm Delete",
  message = "Are you sure you want to delete this item?",
  apiEndpoint,
  deleteId,
  onCancel,
  refetchApi,
}: DeleteConfirmationProps) {
  const onConfirm = async () => {
    try {
      const response = await request.delete(apiEndpoint + deleteId);
      if (response?.data?.status) {
        toast.success(response?.data?.message);
        refetchApi?.();
        onCancel();
      }
    } catch (error) {
      console.log(
        error?.response?.data?.message ||
          "An error occurred. Please try again.",
      );
    }
  };
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "16px",
          boxShadow: "0 8px 32px rgba(0,0,0,0.12)",
        },
      }}
    >
      <DialogTitle sx={{ pb: 1, pt: 2 }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
          <Box
            sx={{
              width: 40,
              height: 40,
              borderRadius: "10px",
              background:
                "linear-gradient(135deg, rgba(239, 68, 68, 0.1) 0%, rgba(185, 28, 28, 0.1) 100%)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <WarningAmberIcon sx={{ color: "#ef4444", fontSize: 24 }} />
          </Box>
          <Typography
            variant="h6"
            sx={{ fontWeight: 700, color: "#1a1f3a", fontSize: "1.1rem" }}
          >
            {title}
          </Typography>
        </Box>
      </DialogTitle>
      <DialogContent sx={{ pt: 1.5, pb: 2 }}>
        <Typography
          sx={{ color: "#64748b", lineHeight: 1.5, fontSize: "0.85rem" }}
        >
          {message}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2.5, gap: 1 }}>
        <Button
          onClick={onCancel}
          sx={{
            borderRadius: "8px",
            px: 2.5,
            py: 0.6,
            textTransform: "none",
            fontWeight: 600,
            fontSize: "0.85rem",
            color: "#64748b",
            "&:hover": {
              background: "#f8fafc",
            },
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          sx={{
            background: "linear-gradient(135deg, #ef4444 0%, #b91c1c 100%)",
            borderRadius: "8px",
            px: 2.5,
            py: 0.6,
            textTransform: "none",
            fontWeight: 600,
            fontSize: "0.85rem",
            boxShadow: "0 2px 8px rgba(239, 68, 68, 0.3)",
            "&:hover": {
              background: "linear-gradient(135deg, #dc2626 0%, #991b1b 100%)",
              boxShadow: "0 4px 12px rgba(239, 68, 68, 0.4)",
            },
          }}
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
}
